import React, { Suspense, lazy } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import {
    BrowserRouter as Router,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';

import { WebPortalState } from './redux/store';
import { getUser } from './redux/actions/userManagementActions';
//Pages
const Index = lazy(() => import('./pages/Index/Index'));
const OpenBankingHeader = lazy(() => import('./components/OpenBankingHeader/OpenBankingHeader'));
const UserHome = lazy(() => import('./pages/UserHome/UserHome'));
const CreateApplication = lazy(() => import('./pages/CreateApplication/CreateApplication'));
const ApplicationDetails = lazy(() => import('./pages/ApplicationDetails/ApplicationDetails'));
const DataManagementPeople = lazy(() => import('./pages/DataManagementPeople/DataManagementPeople'));
const DataManagementPerson = lazy(() => import('./pages/DataManagementPerson/DataManagementPerson'));
const DataManagementAccount = lazy(() => import('./pages/DataManagementAccount/DataManagementAccount'));
const CreateIOBWSToken = lazy(() => import('./pages/CreateIOBWSToken/CreateIOBWSToken'));
const ScaPage = lazy(() => import('./pages/SCAPage/SCAPage'));
const PaymentPage = lazy(() => import('./pages/PaymentPage/PaymentPage'));
const SignIn = lazy(() => import('./pages/SignIn/SignIn'));
const ProfileInfo = lazy(() => import('./pages/ProfileInfo/ProfileInfo'));
const EmailPage = lazy(() => import('./pages/EmailConfirmation/EmailConfirmation'));
const GoLive = lazy(() => import('./pages/GoLive/GoLive'));
const CompanyDetails = lazy(() => import('./pages/CompanyInfo/CompanyInfo'))

export default function OpenBankingRouter() {
    const authenticated = useSelector((state: WebPortalState) => state.tokenAssistant.loggedIn)
    const verifiedEmail = useSelector((state: WebPortalState) => state.developerState.verified)

    const { pathname } = globalThis.location
    const noHeader = pathname.match('/sca/') || pathname.match('/payments/authorize') || pathname.match('/payments/cancel')
    const dispatch = useDispatch()

    const renderAuthenticatedRoutes = () => {
        if (!authenticated) {
            return (
                <Switch>
                    <Redirect from='/user/:anything' to='/signin' />
                </Switch>
            );
        }

        if (!verifiedEmail) {
            return (
                <Switch>
                    <Route exact path='/user/info' component={ProfileInfo}></Route>
                    <Redirect from='/user/:anything' to='/user' />
                </Switch>
            );
        }

        return (
            <>
                <>{dispatch(getUser())}</>
                <Switch>
                    <Route exact path='/user/Applications/create' component={CreateApplication}></Route>
                    <Route exact path='/user/app/:id/golive' component={GoLive}></Route>
                    <Route exact path='/user/app/:id' component={ApplicationDetails}></Route>
                    <Route exact path='/user/DataManagement/people/:id' component={DataManagementPerson}></Route>
                    <Route exact path='/user/DataManagement/people/account/:id' component={DataManagementAccount}></Route>
                    <Route exact path='/user/generateToken' component={CreateIOBWSToken}></Route>
                    <Route exact path='/user/info' component={ProfileInfo}></Route>
                    <Route exact path='/user/companies' component={CompanyDetails}></Route>
                </Switch>
            </>
        );
    };

    return (
        <Router>
            <Suspense fallback={<div></div>}>
                {noHeader ? '' : <OpenBankingHeader />}
                <Switch>
                    <Route exact path='/' component={Index} />
                    <Route exact path='/signin' component={SignIn} />
                    <Route path='/sca/authorize' component={ScaPage} />
                    <Route path='/payments/:method' component={PaymentPage} />
                    <Route path='/emailverification' component={EmailPage}></Route>
                    <Route exact path='/user' component={UserHome} />
                    <Route exact path='/user/DataManagement/people' component={DataManagementPeople}></Route>
                    {renderAuthenticatedRoutes()}
                </Switch>
            </Suspense></Router>
    );
}
